import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "../styles/ticket.module.css";
import styles2 from "../styles/pagination.module.css";
import Tickets from "../components/Tickets";
import UserContext from "../context/user/UserContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StateContext from "../context/state/StateContext";
import Filter from "../components/Filter";
import { MultipleLine } from "../components/Analytics/MultipleLine";
import Lottie from "lottie-react";
import { FiRotateCw } from "react-icons/fi";
import io from "socket.io-client";
import animation from "../lottie-icons/no_task.json";
import { toast } from "react-toastify";
import hourglass from "../lottie-icons/hourglass.json";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../components/Spinner";
import ReactPaginate from "react-paginate";
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";

const OurTickets = () => {
  const { user, getTickets, verifyUser } = useContext(UserContext);
  const {
    setModal,
    token,
    tickets,
    allTickets,
    setLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    setLoad,
    setToDate,
    setFromDate,
    setFilters,
    setFilterItem,
    setSortBy,
    setSortOrder,
    setSearchValue,
    setBy_search,
    setMe_search,
    hasMore,
    load,
    fetching,
  } = useContext(StateContext);

  const [refresh, setRefresh] = useState(false); // State to trigger refresh
  const [activeTickets, setActiveTickets] = useState("today");

  const fetchMoreData = async () => {
    if (hasMore && fetching === false) {
      await getTickets(currentPage + 1);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  const formatDate = (dateString) => {
    const options = { year: "2-digit", month: "long", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
  };

  const verifyAndRedirect = async () => {
    setLoading({ open: true, text: "Verifying..." });

    const result = await verifyUser(); // Call the function from context
    if (result?.success) {
      if (user?.verified === false) {
        navigate("/"); // Redirect if the user is not verified
      } else if (user?.role === "agency") {
        navigate("/dashboard/support");
      }
    } else {
      toast.error("Verification failed. Redirecting to login.");
      navigate("/"); // Redirect on failure
    }

    setLoading({ open: false, text: "" });
  };

  const fetchtickets = async () => {
    try {
      setLoad(true);

      const params = new URLSearchParams(location.search);
      const pageFromUrl = parseInt(params.get("page")) || 1;
      const filtersParam = params.get("filters");
      const fromParams = params.get("fromDate");
      const toParams = params.get("toDate");
      const searchParams = params.get("search");
      const sortParams = params.get("sort") || "date";
      const orderParams = params.get("order") || "desc";
      const byMeParams = params.get("byMe");
      const toMeParams = params.get("toMe");
      const activeParam = params.get("active") || "today";

      let updatedFilters = {};
      updatedFilters = filtersParam ? JSON.parse(filtersParam) : {}; // Convert JSON string back to an object

      setFilters(updatedFilters);
      let newFilters =
        updatedFilters &&
        Object.entries(updatedFilters).flatMap(
          ([key, values]) => values.map((value) => ({ key, value })) // Store key-value pairs
        );
      if (fromParams && toParams) {
        const deadline = `${formatDate(fromParams)} to ${formatDate(toParams)}`;

        // Remove any previous "deadline" filter and add the new one
        newFilters = newFilters.filter((item) => item.key !== "deadline");
        newFilters.push({ key: "deadline", value: deadline });
      }
      setFilterItem(newFilters);
      setToDate(toParams);
      setFromDate(fromParams);
      setSearchValue(searchParams);
      setSortBy(sortParams);
      setSortOrder(orderParams);
      setBy_search(byMeParams);
      setMe_search(toMeParams);
      setCurrentPage(pageFromUrl);
      setActiveTickets(activeParam);
      await getTickets(
        pageFromUrl,
        updatedFilters,
        fromParams,
        toParams,
        searchParams,
        sortParams,
        orderParams,
        byMeParams,
        toMeParams,
        activeParam
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (token) {
      verifyAndRedirect();
    }
  }, []);

  useEffect(() => {
    if (user && user.role === "agency") {
      navigate("/dashboard/support");
    }
  }, [user]);

  useEffect(() => {
    fetchtickets();
  }, [location.search]);

  const handlePageClick = async (event) => {
    const pageNumber = event.selected + 1; // Get selected page
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set("page", pageNumber); // Update the page number
    navigate(`?${currentParams.toString()}`);
  };

  const handleActiveTickets = (value) => {
    setActiveTickets(value);
    const params = new URLSearchParams(window.location.search);
    params.set("active", value); // Update the active tickets
    params.delete("page")
    // params.delete("filters");
    // params.delete("fromDate");
    // params.delete("toDate");
    // params.delete("search");
    navigate(`?${params.toString()}`);
  };

  return (
    <>
      <div className="container-fluid px-0">
        <div className="heading">
          <h3>My Tasks</h3>
          {user.role === "hod" || user.role === "admin" ? (
            <div
              className="btn-div"
              onClick={() => setModal({ open: true, component: "Add" })}
            >
              <button className="learn-more" id="add">
                <span className="circle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Add Task</span>
              </button>
            </div>
          ) : null}
        </div>
        <div className="d-flex align-items-end justify-content-between">
          <Filter tickets={tickets} allTickets={allTickets} />
        </div>
        <div className="flex items-center justify-center gap-2 my-2 flex-wrap">
          <button className={`button2 outline ${activeTickets === "today" ? 'active' : ''}`} onClick={() => handleActiveTickets("today")}>Today</button>
          <button className={`button2 outline ${activeTickets === "week" ? 'active' : ''}`} onClick={() => handleActiveTickets("week")}>This Week</button>
          <button className={`button2 outline ${activeTickets === "month" ? 'active' : ''}`} onClick={() => handleActiveTickets("month")}>This Month</button>
          <button className={`button2 outline ${activeTickets === "All Task" ? 'active' : ''}`} onClick={() => handleActiveTickets("All Task")}>All Task</button>
        </div>
        <div className="d-flex align-items-end justify-content-end w-100">
          <button
            onClick={() => {
              setRefresh(true);
              getTickets().then(() => setRefresh(false));
            }}
            className={`refresh ${refresh ? "active" : ""}`} // Add `active` class when loading
          >
            <FiRotateCw />
            {refresh ? "Refreshing..." : "Refresh"}
          </button>
        </div>
        <div className="row">
          <div className="col-lg-12 col-12 mt-lg-0 mt-2">
            <div className={styles.tickets}>
              <div className={styles2.pagination} style={{ overflowX: "auto" }}>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={<FaAngleRight />}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3} // Show only the current page
                  marginPagesDisplayed={1}
                  pageCount={totalPages}
                  forcePage={currentPage - 1} // Set the active page directly
                  previousLabel={<FaAngleLeft />}
                  renderOnZeroPageCount={null}
                  containerClassName={styles2.paginationContainer}
                  pageClassName={`${styles2.pageItem} ${
                    load ? styles2.disabledPage : ""
                  }`} // Apply disabled style
                  pageLinkClassName={styles2.pageLink}
                  previousClassName={`${styles2.pageItem} ${
                    load ? styles2.disabledPage : ""
                  }`} // Disable previous button
                  previousLinkClassName={styles2.pageLink}
                  nextClassName={`${styles2.pageItem} ${
                    load ? styles2.disabledPage : ""
                  }`} // Disable next button
                  nextLinkClassName={styles2.pageLink}
                  breakClassName={styles2.pageItem}
                  breakLinkClassName={styles2.pageLink}
                  activeClassName={styles2.activePage}
                  disabledClassName={styles2.disabledPage} // Add a disabled class
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    maxWidth: "320px",
                    width: "100%",
                    margin: "0 auto",
                    overflowX: "auto",
                  }}
                />
              </div>
              {load ? (
                // Loading state
                <div className="d-flex align-items-center justify-content-center w-100">
                  <Lottie
                    className="hourglass"
                    animationData={hourglass}
                    loop={true}
                  />
                </div>
              ) : // <Spinner/>
              tickets && tickets.length > 0 ? (
                // Render tickets when available
                <div>
                  {tickets
                    .slice()
                    // .reverse()
                    .map((item, index) => (
                      <Tickets
                        key={item.id || index}
                        data={item}
                        index={index}
                      />
                    ))}
                </div>
              ) : (
                // No tickets available
                <div className="lottie-animation">
                  <Lottie animationData={animation} loop={true} />
                  <h3>No Task Here</h3>
                  <p>It seems that you don't have any tasks in this list</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurTickets;
